module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('div', {
    staticClass: "frame-2"
  }, [_c('img', {
    staticClass: "frame-3",
    attrs: {
      "alt": "LoneStarhalftitledisplay.jpg",
      "src": "image/LoneStarhalftitled_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-2"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-3"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('div', {
    staticClass: "frame-2"
  }, [_c('img', {
    staticClass: "frame-4",
    attrs: {
      "alt": "LoneStardisplay.jpg",
      "src": "image/LoneStardisplay_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-4"
  }, [_c('span', {
    staticClass: "char-style-override-1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frame-2"
  }, [_c('img', {
    staticClass: "frame-5",
    attrs: {
      "alt": "PELOGO.TIF",
      "src": "image/PELOGO_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-5"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-6"
  }, [_vm._v("PELICAN PUBLISHING COMPANY")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("Gretna")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v(" 2016")]), _c('span', {
    staticClass: "char-style-override-3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Copyright © 2016")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("By Melanie Chrismer")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("The word “Pelican” and the depiction of a pelican are")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("trademarks of Pelican Publishing Company, Inc., and are")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("registered in the U.S. Patent and Trademark Office.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_vm._v("Names: Chrismer, Melanie, author.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_vm._v("Title: Lone Star legacy : the Texas Rangers then and now / Melanie Chrismer.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', [_vm._v("Description: Gretna, Louisiana : Pelican Publishing Company, Inc., [2016] | ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_vm._v("\tIncludes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_vm._v("Identifiers: LCCN 2015050299 | ISBN 9781455621040 (pbk. : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_vm._v("Subjects: LCSH: Texas Rangers--Juvenile literature. | Law enforcement--Texas--History--Juvenile literature. | Texas--History--Juvenile literature.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_vm._v("Classification: LCC F391 .C486 2016 | DDC 363.2/09764--dc23 LC record available at "), _c('a', {
    attrs: {
      "href": "http://lccn.loc.gov/2015050299",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "Hyperlink char-style-override-5"
  }, [_vm._v("http://lccn.loc.gov/2015050299")])]), _c('span', {
    staticClass: "Hyperlink char-style-override-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "Hyperlink char-style-override-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "Hyperlink char-style-override-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "Hyperlink char-style-override-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "Hyperlink char-style-override-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "Hyperlink char-style-override-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frame-2"
  }, [_c('img', {
    staticClass: "frame-6",
    attrs: {
      "alt": "1597.jpg",
      "src": "image/1597.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "Hyperlink char-style-override-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Published by Pelican Publishing Company, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-2"
  }, [_vm._v("1000 Burmaster Street, Gretna, Louisiana 70053"), _c('span')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("To the Texas Rangers, past, present, and future. May the Lord keep our Rangers safe, our liberty secure, and our Texas free.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("For Lauren and Tim")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("with love")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-6"
  }, [_vm._v("The great peace officer must have three qualities: courage, intelligence, and character. . . . Such a man cannot be scared, bought, or fooled.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Walter Prescott Webb "), _c('br')]), _c('span', {
    staticClass: "char-style-override-6"
  }, [_vm._v("The Texas Rangers: A Century of Frontier Defense")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-2"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "x-1-chapter-number-15"
  }), _vm._v(" "), _c('p', {
    staticClass: "x-2-ch-title-15"
  }, [_vm._v("Contents"), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("\tAcknowledgments\t 9")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("\tIntroduction\t 11")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("Chapter 1\tOne Legacy\t 15")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("Chapter 2\tBeginning Times\t 21")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("Chapter 3\tThe War for Independence\t29")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("Chapter 4\tThe Republic\t 35")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("Chapter 5\tMexican Invasions Continue\t 45")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("Chapter 6\tRepublic Law Becomes State Law\t 49")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("Chapter 7\tReturn to Service\t 57")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("Chapter 8\tA New Century\t 67")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("Chapter 9\tThe Depression Years\t 81")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("Chapter 10\tThe DPS Takes the Reins\t 87")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("Chapter 11\tThe Last Third of the Twentieth Century\t 97")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("Chapter 12\tTexas Ranger Teamwork\t 105")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("Chapter 13\tToday’s Texas Ranger\t 111")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("Chapter 14\tHonoring the Legacy\t 119")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("\tNotes\t 125")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("\tBibliography\t 131")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("\tIndex\t 135")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-528b5a0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LONHeFM01.vue
// module id = 57
// module chunks = 0